module.exports = "<div [ngClass]=\"customAlertClasses\">\n   <ul *ngIf=\"multiple === true\">\n     <li *ngIf=\"title\"><strong>{{title}}</strong></li>\n     <li *ngFor=\"let text of textObject\"><i></i> {{text}}</li>\n   </ul>\n  <span *ngIf=\"multiple === false\" class=\"single-text\"><i></i>{{title}}</span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/custom-alert/custom-alert.component.html
// module id = ./src/app/shared/components/custom-alert/custom-alert.component.html
// module chunks = main